import { createI18n } from 'vue-i18n'
import { App } from 'vue'
import messages from '@/locales'
import type { AvailableLocales, MessageSchema } from '@/locales/types'

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $t: (key: keyof MessageSchema, values?: Record<string, unknown>) => string
  }
}

export default {
  install: (app: App) => {
    const i18n = createI18n<[MessageSchema], AvailableLocales>({
      legacy: false,
      locale: 'en',
      fallbackLocale: 'en',
      messages,
      missingWarn: false,
      fallbackWarn: false
    })

    app.use(i18n)
    
    // Type-safe global property
    app.config.globalProperties.$t = i18n.global.t
  }
}
